module.exports = __webpack_public_path__ + "img/支付宝.a0f05fa1.svg";